// extracted by mini-css-extract-plugin
export default {"Wrapper":"LottoAssistant_Wrapper__JfYX-"};